export const environment = {
  production: true,
  apiUrl: '/unico-api'
};
